"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCreateTransport = exports.PaymentTransport = exports.SearchPaymentsQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
const customer_contact_transport_1 = require("../customer/customer-contact-transport");
exports.SearchPaymentsQuery = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    invoiceID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    paymentSentAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentSentBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentReceivedAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    paymentReceivedBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    dateAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    dateBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    paymentIdentifer: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripeChargeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripePayoutID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
exports.PaymentTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    date: typebox_1.Type.String(),
    paymentSentDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    paymentReceivedDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    amount: typebox_1.Type.Number(),
    amountDollars: typebox_1.Type.Number(),
    paymentMethod: typebox_1.Type.String(),
    enteredByUserID: typebox_1.Type.String(),
    paymentIdentifier: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripeChargeID: typebox_1.Type.Optional(typebox_1.Type.String()),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceParentID: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripePayoutID: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Optional(typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    })),
});
exports.PaymentCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.PaymentTransport, ['id', 'date', 'amount', 'amountDollars', 'enteredByUserID']),
    typebox_1.Type.Object({
        date: typebox_1.Type.Optional(typebox_1.Type.String()),
        amount: typebox_1.Type.Optional(typebox_1.Type.Number()),
        amountDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
        haulerVendorID: typebox_1.Type.Optional(typebox_1.Type.String()),
        revenueShare: typebox_1.Type.Optional(typebox_1.Type.Number()),
        revenueShareAmount: typebox_1.Type.Optional(typebox_1.Type.Number()),
        contactsToNotify: typebox_1.Type.Optional(typebox_1.Type.Array(customer_contact_transport_1.CustomerContactTransport)),
    }),
]);
//# sourceMappingURL=payment-transport.js.map